module.exports = {"business_name":"Firmenname","enter_business_name":"Geben Sie den Firmennamen","select_business_category":"Wählen Sie Business-Kategorie","specify_further":"Geben Sie weiter","fixed_location":"Werden Sie in erster Linie iZettle an einem festen Standort verwenden?","seasonal_business":"Haben Sie ein saisonales Geschäft?","select_turnover":"Wählen Umsatz mit iZettle","select_average_transaction":"Wählen durchschnittliche Transaktionsgröße","estimate_per_year":"Schätzung pro Jahr"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/de/company.json
// module id = 478
// module chunks = 248 1700